import Reveal from "@/components/feature/Reveal";
import { partners } from "@/mocks/home";

const loopItems = [...partners, ...partners, ...partners, ...partners];

export default function PartnersSection() {
  return (
    <section id="partners" className="bg-background-100 pt-6 pb-14 md:pt-10 md:pb-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <Reveal className="text-center">
          <p className="font-label text-[36px] font-bold tracking-[0.15em] text-foreground-700 md:text-[40px]">
            PARTNERS
          </p>
          <h2 className="mt-3 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-7xl">
            取引先企業
          </h2>
          <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            私たちは、さまざまな企業・団体さまとともに事業を展開しています。
          </p>
        </Reveal>
      </div>

      <div className="relative mt-6 md:mt-8">
        <div className="group relative overflow-hidden">
          <div className="flex w-max animate-[partners-marquee_32s_linear_infinite] group-hover:[animation-play-state:paused]">
            {loopItems.map((partner, index) => (
              <div
                key={`${partner.name}-${index}`}
                className="flex w-[300px] shrink-0 items-center justify-center px-4 md:w-[360px] md:px-6"
                aria-hidden={index >= partners.length}
              >
                <div className="flex h-20 w-full items-center justify-center rounded-lg border border-background-200 bg-background-50 px-6 md:h-24 md:px-8">
                  <img
                    src={partner.logo}
                    alt={`${partner.name}のロゴ`}
                    title={partner.name}
                    className="h-9 w-auto max-w-full object-contain md:h-11"
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-background-100 to-transparent md:w-24" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-background-100 to-transparent md:w-24" />
        </div>
      </div>
    </section>
  );
}